const mediaQueryKeys = {
    media: () => ['media'],
    file: (url: string) => [...mediaQueryKeys.media(), url],
    inMemoryFiles: () => [...mediaQueryKeys.media(), 'memory'],
};

export { mediaQueryKeys };
